import React, { useEffect } from 'react'
import OpenedSidebar from "../../components/openedSidebar"
import MedicalView from '../../components/views/MedicalView';
import { connect, useSelector} from 'react-redux';
import { dashboardActions } from '../../redux-utils/actions/dashboard-actions';
import { useAuth } from '../../custom-hooks/useAuth';
import Loader from '../../components/Loader';
import ClosedSidebar from '../../components/closedSidebar';


const { allParticipantAction } = dashboardActions;

function MedicalData({allParticipantResult}) {
  const data = allParticipantResult?.allParticipantData || [];
  const isOpened = useSelector((state) => state.sidebarState.isOpen);
  
  

  if(allParticipantResult.allParticipantData && allParticipantResult.allParticipantData.length > 0) {
    return (
      <MedicalView data={data} />
    )
  }

  return (
    (allParticipantResult.status === "" || allParticipantResult.status === "all_participant_fetch_start") ? (
      <div className="bg-[#F9F9F9] font-sans flex">
         {isOpened ? <OpenedSidebar /> : <ClosedSidebar/>}
        <Loader />
      </div>
    ) :
    (
      <MedicalView data={data} />
    )
  )
}

const areEqual = (prevProps, nextProps) => {
  return prevProps.allParticipantResult.allParticipantData === nextProps.allParticipantResult.allParticipantData
};
const MedicalMemo = React.memo(MedicalData, areEqual)

function Medical(props) {
  const { 
    allParticipantDispatchAction,
    allParticipantResult
  } = props;

  const { getLogin } = useAuth();
  const loginStorage = JSON.parse(getLogin());

  useEffect(() => {
    const allParam = {
      token: loginStorage && loginStorage.loginData.data.token
    }

    allParticipantDispatchAction(allParam);

  }, [])

  return (
    <>
      <MedicalMemo 
        allParticipantDispatchAction={allParticipantDispatchAction} 
        allParticipantResult={allParticipantResult}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  allParticipantResult: state.dashboardState
});

const mapDispatchToProps = dispatch => ({
  allParticipantDispatchAction: (param) => dispatch(allParticipantAction(param)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Medical);